// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
/* import BootstrapVue from 'bootstrap-vue' */
import VueI18n from 'vue-i18n'
import AxiosApis from '@/plugins/axiosApis'
import VueMeta from 'vue-meta'
import * as VueCookies from './plugins/vue-cookies'
import store from '@/store'
import i18n from '@/plugins/i18n.js'
import i18nHelpers from '@/helpers/i18n.helpers'
import helpers from './helpers'
import domains from '_static/domains.json'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'
import validators from './plugins/validators'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import VueSession from 'vue-session'
import { VBTooltipPlugin, VBTogglePlugin, BootstrapVueIcons } from 'bootstrap-vue'
import VueScrollTo from 'vue-scrollto'
import registerGlobalComponents from '@/plugins/registerGlobalComponents'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import VueGtag from 'vue-gtag'
import vco from 'v-click-outside'
import VueHtml2Canvas from 'vue-html2canvas'
import regeneratorRuntime from "regenerator-runtime"
import vuelidateErrorExtractor, { templates } from "vuelidate-error-extractor"
import Chat from '@/components/vue-beautiful-chat'
import { API_TOKEN_COOKIE_NAME } from '@/constants/cookies'
import { getEnvironmentName, getCountry } from '@/helpers/global.helpers'

if (window.location.href.includes('openlegal') && !window.location.href.includes('/abogados')) {
  /* require('../static-appopensalud/css/openlegal/colors.scss') */
  require('../static-appopensalud/css/openlegal/bootstrap-custom-theme-morillas-openlegal.scss')
} else {
  /* require('../static-appopensalud/css/scss/colors.scss') */
  require('../static-appopensalud/css/bootstrap-custom-theme-morillas.scss')
}

import '../static-appopensalud/css/scss/misc.scss'

if (window.location.href.includes('opensaludprime')) {
  Vue.use(VueGtag, {
    config: { id: 'G-MNCV80RN1Y' }
  })
}

import VueTreeNavigation from 'vue-tree-navigation'
import uiHelpers from '@/helpers/ui.helpers'

Vue.use(VueSession, { persist: true })
/* Vue.use(BootstrapVue) */
Vue.use(VueI18n)
Vue.use(VueCookies)
Vue.use(AxiosApis, { store })
Vue.use(Vuex)
Vue.use(VueMeta)
Vue.use(VBTooltipPlugin)
Vue.use(VBTogglePlugin)
Vue.use(BootstrapVueIcons)
Vue.use(registerGlobalComponents)
Vue.use(VueHtml2Canvas)
Vue.use(regeneratorRuntime)
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  y: false
})
Vue.use(vco)
Vue.use(Chat)
Vue.use(VueTreeNavigation)

Vue.use(vuelidateErrorExtractor, { 
  /**
   * Optionally provide the template in the configuration. 
   * or register like so Vue.component("FormField", templates.singleErrorExtractor.foundation6)
   */
  template: templates.singleErrorExtractor.bootstrap4, // you can also pass your own custom template
})

/* Vue.use(VueTreeNavigation) */

// Used to register layout components globally (allows using it without importing in single vue component file)
const requireComponent = require.context('./components/layouts', true, /[A-Z]\w+\.(vue|js)$/)

require("babel-core/register");
require("babel-polyfill");

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)
  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

Sentry.init({
  Vue: Vue,
  autoSessionTracking: true,
  dsn: 'https://f427a5a410a9d72c9775e322c07977a0@o4508794609860609.ingest.de.sentry.io/4508794677493840',
  integrations: [
    new Integrations.BrowserTracing(),
    new VueIntegration({
      Vue,
      tracing: true,
      attachProps: true
    })
  ],
  tracingOptions: {
    trackComponents: true
  },
  sendDefaultPii: true,
	environment: `${getEnvironmentName()}-${getCountry()}`
})

Vue.config.errorHandler = function (err, vm, info) {
  Sentry.captureException(`Vuejs Error: ${err.stack}\nComponent: ${vm != null ? vm.$options.name : ''}\nInfo: ${info}`)
  // Vue.rollbar.error(`Vuejs Error: ${err.stack}\nComponent: ${vm != null ? vm.$options.name : ''}\nInfo: ${info}`)
  console.error(err)
}

Vue.config.productionTip = false

// Get query param 't' from url
const urlParams = new URLSearchParams(window.location.search)
const token = urlParams.get('t') || urlParams.get('api_token') || urlParams.get('token')

Vue.prototype.$apiToken = window.$cookies.get(API_TOKEN_COOKIE_NAME) || token
Vue.prototype.$helpers = helpers
Vue.prototype.$uiHelpers = uiHelpers
Vue.prototype.$i18nHelpers = i18nHelpers
Vue.prototype.$domains = domains
/* Vue.prototype.$filters = Vue.options.filters */
Vue.prototype.$validators = validators
Vue.prototype.$history = window.history

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  i18n,
  store,
  router,
  vuetify,
  template: '<App/>',
  components: { App },
  mounted: function () {}
}).inEs

window.root = vm



// WEBPACK FOOTER //
// ./src/main.js